const AppointmentRequest = (api: any) => ({
  search: (data: any) => api.post('/api/v1/requests/search', data, {}),
  updateStatus: (requestId: number, statusId: number) => api.put(`/api/v1/requests/${requestId}`, {}, { statusId }),
});

export default AppointmentRequest;
